import React, { useEffect, useState } from 'react';
import { orgsApi } from '../services/api';
import { ORG_TYPES } from '../lib/supabase';

// Org workspace switcher. Visible when the account is a consultant OR holds >=2 orgs.
// Only consultants can add new orgs ("create-gated, switch-open").
export default function OrgSwitcher() {
  const [orgs, setOrgs] = useState([]);
  const [accountType, setAccountType] = useState('standard');
  const [open, setOpen] = useState(false);
  const [adding, setAdding] = useState(false);
  const [name, setName] = useState('');
  const [type, setType] = useState('pe');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    orgsApi.list()
      .then((res) => { setOrgs(res.data.organizations || []); setAccountType(res.data.account_type || 'standard'); })
      .catch(() => {});
  }, []);

  const isConsultant = accountType === 'consultant';
  const showSwitcher = isConsultant || orgs.length >= 2;
  if (!showSwitcher) return null;

  const active = orgs.find((o) => o.active) || orgs[0];

  const switchTo = async (orgId) => {
    if (orgId === active?.org_id) { setOpen(false); return; }
    try { await orgsApi.switch(orgId); window.location.reload(); }
    catch { setError('Could not switch organization.'); }
  };

  const submitAdd = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setBusy(true); setError(null);
    try { await orgsApi.add(name.trim(), type); window.location.reload(); }
    catch (err) { setError(err?.response?.data?.error || 'Could not add organization.'); setBusy(false); }
  };

  return (
    <div style={{ position: 'relative' }}>
      <button type="button" onClick={() => setOpen((o) => !o)}
        style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'none', border: '1px solid #e2e8f0', borderRadius: 8, padding: '6px 10px', cursor: 'pointer', font: 'inherit', maxWidth: 220 }}>
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{active?.name || 'Select workspace'}</span>
        <span style={{ fontSize: 9 }}>▼</span>
      </button>

      {open && (
        <div style={{ position: 'absolute', top: '100%', left: 0, marginTop: 4, minWidth: 240, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 8, boxShadow: '0 6px 20px rgba(0,0,0,0.08)', zIndex: 50, padding: 6 }}>
          {orgs.map((o) => (
            <button key={o.org_id} type="button" onClick={() => switchTo(o.org_id)}
              style={{ display: 'flex', justifyContent: 'space-between', width: '100%', textAlign: 'left', background: o.active ? '#eef2ff' : 'none', border: 'none', borderRadius: 6, padding: '8px 10px', cursor: 'pointer', font: 'inherit' }}>
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{o.name}</span>
              <span style={{ color: '#94a3b8', fontSize: 11 }}>{o.role}</span>
            </button>
          ))}
          {isConsultant && (
            <button type="button" onClick={() => { setAdding(true); setOpen(false); }}
              style={{ width: '100%', textAlign: 'left', background: 'none', border: 'none', borderTop: '1px solid #f1f5f9', marginTop: 4, padding: '8px 10px', cursor: 'pointer', color: '#161f4a', font: 'inherit' }}>
              + Add organization
            </button>
          )}
        </div>
      )}

      {adding && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }} onClick={() => !busy && setAdding(false)}>
          <form onClick={(e) => e.stopPropagation()} onSubmit={submitAdd}
            style={{ background: '#fff', borderRadius: 12, padding: 24, width: 380, maxWidth: '90vw' }}>
            <h3 style={{ margin: '0 0 12px' }}>Add organization</h3>
            <label style={{ display: 'block', fontSize: 13, color: '#475569', marginBottom: 4 }}>Name</label>
            <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Client firm name" autoFocus
              style={{ width: '100%', padding: '8px 10px', border: '1px solid #cbd5e1', borderRadius: 8, marginBottom: 12, boxSizing: 'border-box' }} />
            <label style={{ display: 'block', fontSize: 13, color: '#475569', marginBottom: 4 }}>Type</label>
            <select value={type} onChange={(e) => setType(e.target.value)}
              style={{ width: '100%', padding: '8px 10px', border: '1px solid #cbd5e1', borderRadius: 8, marginBottom: 16 }}>
              {ORG_TYPES.filter((t) => t.value !== 'consultant').map((t) => (
                <option key={t.value} value={t.value}>{t.label}</option>
              ))}
            </select>
            {error && <div style={{ color: '#b91c1c', fontSize: 13, marginBottom: 10 }}>{error}</div>}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <button type="button" onClick={() => setAdding(false)} disabled={busy}
                style={{ padding: '8px 14px', border: '1px solid #cbd5e1', borderRadius: 8, background: '#fff', cursor: 'pointer' }}>Cancel</button>
              <button type="submit" disabled={busy || !name.trim()}
                style={{ padding: '8px 14px', border: 'none', borderRadius: 8, background: '#161f4a', color: '#fff', cursor: 'pointer' }}>{busy ? 'Adding…' : 'Add'}</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
